import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Routes, RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { HttpClientModule } from '@angular/common/http';

import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';

import { MatListModule } from '@angular/material/list';

import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'ng2-tooltip-directive';

import { NgxSpinnerModule } from 'ngx-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { EmailSentComponent } from './modals/email-sent/email-sent.component';
import { DeleteCaptureComponent } from './components/tools/capture-tool/delete-capture/delete-capture.component';
import { MapHeaderComponent } from './components/map-header/map-header.component';
import { MapLayoutComponent } from './components/map-layout/map-layout.component';
import { MapComponent } from './components/map/map.component';
import { SidePanelsComponent } from './components/side-panels/side-panels.component';
import { AdvanceSelectComponent } from './components/tools/advance-select/advance-select.component';
import { AnnotationComponent } from './components/tools/annotation/annotation.component';
import { DeleteAnnotationComponent } from './components/tools/annotation/delete-annotation/delete-annotation.component';
import { EditAnnotationRightComponent } from './components/tools/annotation/edit-annotation-right/edit-annotation-right.component';
import { UploadModalComponent } from './components/tools/annotation/upload-modal/upload-modal.component';
import { ZoomComponent } from './components/tools/annotation/zoom/zoom.component';
import { BookmarkComponent } from './components/tools/bookmark/bookmark.component';
import { DeleteModalComponent } from './components/tools/bookmark/delete-modal/delete-modal.component';
import { MultiDeleteBookmarkComponent } from './components/tools/bookmark/multi-delete-bookmark/multi-delete-bookmark.component';
import { RenameModalComponent } from './components/tools/bookmark/rename-modal/rename-modal.component';
import { AddCaptureFeatureComponent } from './components/tools/capture-tool/add-capture-feature/add-capture-feature.component';
import { CaptureToolComponent } from './components/tools/capture-tool/capture-tool.component';
import { ConfirmationDialogComponent } from './components/tools/capture-tool/confirmation-dialog/confirmation-dialog.component';
import { EditFeatureCaptureComponent } from './components/tools/capture-tool/edit-feature-capture/edit-feature-capture.component';
import { ErrorCaptureToolModelComponent } from './components/tools/capture-tool/error-capture-tool-model/error-capture-tool-model.component';
import { UpdateCaptureComponent } from './components/tools/capture-tool/update-capture/update-capture.component';
import { ChatComponent } from './components/tools/chat/chat.component';
import { DownloadViewComponent } from './components/tools/download-view/download-view.component';
import { FeatureNameComponent } from './components/tools/feature-name/feature-name.component';
import { PrePlansEditComponent } from './components/tools/feature-name/pre-plans-edit/pre-plans-edit.component';
import { FeaturesListComponent } from './components/tools/features-list/features-list.component';
import { GoogleStreetViewComponent } from './components/tools/google-street-view/google-street-view.component';
import { InformationComponent } from './components/tools/information/information.component';
import { LegendToolComponent } from './components/tools/legend-tool/legend-tool.component';
import { LiveShareGeoLockComponent } from './components/tools/live-share-geo-lock/live-share-geo-lock.component';
import { LiveShareComponent } from './components/tools/live-share/live-share.component';
import { LiveshareEmbedComponent } from './components/tools/liveshare-embed/liveshare-embed.component';
import { MetricxComponent } from './components/tools/metricx/metricx.component';
import { PrintviewComponent } from './components/tools/printview/printview.component';
import { QueryComponent } from './components/tools/query/query.component';
import { UIdropDownSearchComponent } from './components/tools/uidrop-down-search/uidrop-down-search.component';
import { CsvFileComponent } from './components/tools/view-and-export-data/csv-file/csv-file.component';
import { DataViewComponent } from './components/tools/view-and-export-data/data-view/data-view.component';
import { MailLabelsComponent } from './components/tools/view-and-export-data/mail-labels/mail-labels.component';
import { MapViewComponent } from './components/tools/view-and-export-data/map-view/map-view.component';
import { PdfTableComponent } from './components/tools/view-and-export-data/pdf-table/pdf-table.component';
import { ViewAndExportDataComponent } from './components/tools/view-and-export-data/view-and-export-data.component';
import { ZoomBoxComponent } from './components/tools/zoom-box/zoom-box.component';
import { ZoomToPerimeterComponent } from './components/tools/zoom-to-perimeter/zoom-to-perimeter.component';
import { AssessopParcelErrorComponent } from './modals/assessop-parcel-error/assessop-parcel-error.component';
import { PaymentInformationComponent } from './modals/payment-information/payment-information.component';
import { QueryLimitComponent } from './modals/query-limit/query-limit.component';
import { ResubscribeDaypassComponent } from './modals/resubscribe-daypass/resubscribe-daypass.component';
import { UpdateComponent } from './modals/resubscribe-daypass/update/update.component';
import { WelcomeCustomComponent } from './modals/welcome-custom/welcome-custom.component';
import { WelcomeParcelComponent } from './modals/welcome-parcel/welcome-parcel.component';
import { WelcomeWildfireDamageComponent } from './modals/welcome-wildfire-damage/welcome-wildfire-damage.component';
import { WelcomeWildfireComponent } from './modals/welcome-wildfire/welcome-wildfire.component';
import { DynamicModalComponent } from './modals/dynamic-modal/dynamic-modal.component';
import { DynamicModalEmbedToolComponent } from './modals/dynamic-modal-embed-tool/dynamic-modal-embed-tool.component';
import { DynamicModalCheckboxTemplateComponent } from './modals/dynamic-modal-checkbox-template/dynamic-modal-checkbox-template.component';
import { MapNotAvailableModalComponent } from './modals/map-not-available-modal/map-not-available-modal.component';
import { PropertyReportsMenuComponent } from './components/tools/feature-name/property-reports-menu/property-reports-menu.component';
import { PropertyDocumentsPaymentComponent } from './components/tools/feature-name/property-documents-payment/property-documents-payment.component';
import { LegendpreviewComponent } from './components/legendpreview/legendpreview.component';
import { NgxColorsModule } from 'ngx-colors';
import { GpsErrorModalComponent } from './modals/gps-error-modal/gps-error-modal.component';
import { DemDownloaderComponent } from './components/tools/dem-downloader/dem-downloader.component';
import { DemDetailComponent } from './components/tools/dem-downloader/dem-detail/dem-detail.component';
import { DeleteDemComponent } from './components/tools/dem-downloader/delete-dem/delete-dem.component';
import { QuillModule } from 'ngx-quill'
const routes: Routes = [
  {
    path: '',
    component: MapLayoutComponent,
    children: [
      {
        path: '',
        component: MapComponent,
      },
    ],
  },
];
@NgModule({
  declarations: [
    MapComponent,
    MapHeaderComponent,
    MapLayoutComponent,
    SidePanelsComponent,
    LegendToolComponent,
    MetricxComponent,
    UIdropDownSearchComponent,
    AdvanceSelectComponent,
    DownloadViewComponent,
    FeaturesListComponent,
    FeatureNameComponent,
    QueryComponent,
    GoogleStreetViewComponent,
    ZoomBoxComponent,
    BookmarkComponent,
    DeleteModalComponent,
    RenameModalComponent,
    LiveShareComponent,
    LiveshareEmbedComponent,
    AnnotationComponent,
    UploadModalComponent,
    EditAnnotationRightComponent,
    InformationComponent,
    ZoomComponent,
    ViewAndExportDataComponent,
    MapViewComponent,
    CsvFileComponent,
    PdfTableComponent,
    MailLabelsComponent,
    DataViewComponent,
    PrintviewComponent,
    PrePlansEditComponent,
    ZoomToPerimeterComponent,
    LiveShareGeoLockComponent,
    CaptureToolComponent,
    DynamicModalComponent,
    EditFeatureCaptureComponent,
    ConfirmationDialogComponent,
    WelcomeParcelComponent,
    WelcomeCustomComponent,
    WelcomeWildfireComponent,
    WelcomeWildfireDamageComponent,
    AddCaptureFeatureComponent,
    MultiDeleteBookmarkComponent,
    DeleteAnnotationComponent,
    QueryLimitComponent,
    DeleteCaptureComponent,
    UpdateCaptureComponent,
    ErrorCaptureToolModelComponent,
    ChatComponent,
    EmailSentComponent,
    AssessopParcelErrorComponent,
    ResubscribeDaypassComponent,
    UpdateComponent,
    PaymentInformationComponent,
    DynamicModalEmbedToolComponent,
    DynamicModalCheckboxTemplateComponent,
    MapNotAvailableModalComponent,
    PropertyReportsMenuComponent,
    PropertyDocumentsPaymentComponent,
    LegendpreviewComponent,
    GpsErrorModalComponent,
    DemDownloaderComponent,
    DemDetailComponent,
    DeleteDemComponent
    ],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    SharedModule,
    HttpClientModule,
    MatSidenavModule,
    MatSlideToggleModule,
    MatDialogModule,
    MatTooltipModule,
    MatListModule,
    MatIconModule,
    TooltipModule,
    FormsModule,
    NgxSpinnerModule,
    NgxColorsModule,
    QuillModule.forRoot()
  ],
})
export class MapModule {}
